import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
export function SavingsSection() {
  return <section className="py-20 bg-cream" data-id="element-119">
      <div className="container mx-auto px-4" data-id="element-120">
        <div className="max-w-4xl mx-auto" data-id="element-121">
          <div className="text-center mb-12" data-id="element-122">
            <h2 className="text-3xl md:text-4xl font-bold text-espresso mb-4 font-serif" data-id="element-123">
              La Matemática es Simple
            </h2>
            <p className="text-gray-600 text-lg" data-id="element-124">
              Deja de gastar $400 al mes en comida rápida fría y sin sabor.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center" data-id="element-125">
            {/* The Old Way */}
            <motion.div initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} className="bg-white p-8 rounded-2xl shadow-sm border border-stone-200 opacity-70" data-id="element-126">
              <h3 className="text-xl font-bold text-gray-500 mb-6 flex items-center gap-2" data-id="element-127">
                <X className="text-red-400" data-id="element-128" />
                La Rutina Actual
              </h3>
              <ul className="space-y-4 text-gray-600" data-id="element-129">
                <li className="flex justify-between border-b border-gray-100 pb-2" data-id="element-130">
                  <span data-id="element-131">Uber Eats (3x semana)</span>
                  <span className="font-mono font-medium" data-id="element-132">$165/mes</span>
                </li>
                <li className="flex justify-between border-b border-gray-100 pb-2" data-id="element-133">
                  <span data-id="element-134">Cenas fuera improvisadas</span>
                  <span className="font-mono font-medium" data-id="element-135">$200/mes</span>
                </li>
                <li className="flex justify-between border-b border-gray-100 pb-2" data-id="element-136">
                  <span data-id="element-137">Comida desperdiciada</span>
                  <span className="font-mono font-medium" data-id="element-138">$50/mes</span>
                </li>
                <li className="flex justify-between pt-2 text-red-500 font-bold text-lg" data-id="element-139">
                  <span data-id="element-140">Total Perdido</span>
                  <span data-id="element-141">~$415/mes</span>
                </li>
              </ul>
            </motion.div>

            {/* The New Way */}
            <motion.div initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.2
          }} className="bg-white p-8 rounded-2xl shadow-xl border-2 border-terracotta relative overflow-hidden" data-id="element-142">
              <div className="absolute top-0 right-0 bg-terracotta text-white text-xs font-bold px-3 py-1 rounded-bl-lg uppercase tracking-wider" data-id="element-143">
                Mejor Opción
              </div>
              <h3 className="text-2xl font-bold text-terracotta mb-6 flex items-center gap-2 font-serif" data-id="element-144">
                <Check className="text-terracotta" data-id="element-145" />
                Método 3 Bases
              </h3>
              <ul className="space-y-4 text-gray-700" data-id="element-146">
                <li className="flex justify-between border-b border-orange-100 pb-2" data-id="element-147">
                  <span data-id="element-148">Guía Digital (Pago Único)</span>
                  <span className="font-mono font-bold text-forest" data-id="element-149">$6,39</span>
                </li>
                <li className="flex justify-between border-b border-orange-100 pb-2" data-id="element-150">
                  <span data-id="element-151">Compras de Super (Semanal)</span>
                  <span className="font-mono font-medium" data-id="element-152">~$80/sem</span>
                </li>
                <li className="flex justify-between border-b border-orange-100 pb-2" data-id="element-153">
                  <span data-id="element-154">Tiempo en cocina</span>
                  <span className="font-mono font-medium" data-id="element-155">10 min/día</span>
                </li>
                <li className="flex justify-between pt-2 text-forest font-bold text-lg" data-id="element-156">
                  <span data-id="element-157">Ahorro Mensual</span>
                  <span data-id="element-158">+$300/mes</span>
                </li>
              </ul>
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}